/**
 * The English source (ADR-119 decision 1): one file per feature, each one plain object of values declared
 * `as const`, joined here under the file's name, which is the first segment of every key in it.
 */

import { ACCOUNT } from "./account.ts";
import { BAG } from "./bag.ts";
import { BANNER } from "./banner.ts";
import { BAR } from "./bar.ts";
import { BELT } from "./belt.ts";
import { COMPANION } from "./companion.ts";
import { CHAT } from "./chat.ts";
import { CHEST } from "./chest.ts";
import { CLOSE } from "./close.ts";
import { CONTROLS } from "./controls.ts";
import { DEATH } from "./death.ts";
import { DOOR } from "./door.ts";
import { LIGHT } from "./light.ts";
import { EDITOR } from "./editor.ts";
import { EDITOR_NOTICE } from "./editorNotice.ts";
import { FEEDBACK } from "./feedback.ts";
import { FIGHT } from "./fight.ts";
import { FLOOR } from "./floor.ts";
import { HARVEST } from "./harvest.ts";
import { HUD } from "./hud.ts";
import { LOADING } from "./loading.ts";
import { LOOK } from "./look.ts";
import { MAIL } from "./mail.ts";
import { MENU } from "./menu.ts";
import { MINIMAP } from "./minimap.ts";
import { MODERATION } from "./moderation.ts";
import { PARTY } from "./party.ts";
import { PERF } from "./perf.ts";
import { QUEUE } from "./queue.ts";
import { READING } from "./reading.ts";
import { REQUEST } from "./request.ts";
import { SETTINGS } from "./settings.ts";
import { STAFF } from "./staff.ts";
import { STATUS } from "./status.ts";
import { STUDIO } from "./studio.ts";
import { TALK } from "./talk.ts";
import { THING } from "./thing.ts";
import { TOUCH } from "./touch.ts";
import { TRAVEL } from "./travel.ts";
import { WALLET } from "./wallet.ts";
import { CHARACTER } from "./character.ts";
import { WHEEL } from "./wheel.ts";
import { WINDOW } from "./window.ts";
import { WORLD_MAP } from "./worldMap.ts";

/**
 * Every English word of the game, by feature.
 */
export const EN_WORDS = {
  account: ACCOUNT,
  bag: BAG,
  banner: BANNER,
  bar: BAR,
  belt: BELT,
  companion: COMPANION,
  chat: CHAT,
  chest: CHEST,
  close: CLOSE,
  controls: CONTROLS,
  death: DEATH,
  door: DOOR,
  light: LIGHT,
  editor: EDITOR,
  editorNotice: EDITOR_NOTICE,
  feedback: FEEDBACK,
  fight: FIGHT,
  floor: FLOOR,
  harvest: HARVEST,
  hud: HUD,
  loading: LOADING,
  look: LOOK,
  mail: MAIL,
  menu: MENU,
  minimap: MINIMAP,
  moderation: MODERATION,
  party: PARTY,
  perf: PERF,
  queue: QUEUE,
  reading: READING,
  request: REQUEST,
  settings: SETTINGS,
  staff: STAFF,
  status: STATUS,
  studio: STUDIO,
  talk: TALK,
  thing: THING,
  touch: TOUCH,
  travel: TRAVEL,
  wallet: WALLET,
  character: CHARACTER,
  wheel: WHEEL,
  window: WINDOW,
  worldMap: WORLD_MAP,
} as const;
